import React from "react";
import PropTypes from "prop-types";

import {
  ALL_LOCATION_CONTACTS_QUERY,
  LOCATION_CONTACT_PAGINATION_QUERY
} from "../../graphql/Locations/LocationContacts.graphql";

import DataTable from "../DataTable";

import EditLocationContactForm from "./EditLocationContactForm";

const COLUMNS = [
  {
    Header: "Name",
    accessor: "Name",
    id: "Name"
  },
  {
    Header: "Description",
    accessor: "Description",
    id: "Description"
  },
  { Header: "Status", accessor: "Active", id: "Status" },
  {
    Header: "Is Primary",
    accessor: "IsPrimary",
    id: "IsPrimary"
  },
  {
    Header: "Telephone",
    accessor: "Telephone",
    id: "Telephone"
  },
  {
    Header: "Extension",
    accessor: "Extension",
    id: "Extension"
  },
  {
    Header: "Fax",
    accessor: "FaxNo",
    id: "FaxNo"
  },
  {
    Header: "Email",
    accessor: "Email",
    id: "Email"
  }
];

function LocationContactsTable({ id, setModalOpen }) {
  const LocationRecIdRef = parseInt(id);
  return (
    <DataTable
      columns={COLUMNS}
      dataQuery={ALL_LOCATION_CONTACTS_QUERY}
      name="LocationContact"
      paginationQuery={LOCATION_CONTACT_PAGINATION_QUERY}
      where={{ LocationRecIdRef }}
      onRowClick={contact =>
        setModalOpen(
          true,
          <EditLocationContactForm
            contact={contact}
            id={LocationRecIdRef}
            onComplete={() => setModalOpen(false, "")}
          />
        )
      }
    />
  );
}

LocationContactsTable.propTypes = {
  id: PropTypes.number,
  setModalOpen: PropTypes.func
};
export default LocationContactsTable;
